export enum SCRIPT_GENERATOR_METHOD {
  SCRIPT_GENERATOR_IDENTIFY = 'Identify',
  SCRIPT_GENERATOR_API_CALLED = 'OpenAI API Called',
  SCRIPT_GENERATOR_SCRIPT_GENERATED = 'AI Script Generated',
  SCRIPT_GENERATOR_SCRIPT_COPYCONTENT = 'Script Content Copied',
  SCRIPT_GENERATOR_SCRIPT_CONTENT_OPENED = 'Script Content Opened'
}

/**
 * Segment tracking using browser
 * The event data is send directly to Segment
 * @param title
 * @param props
 */
export const segmentTrack = (title: string, props?: {}) => {
  try {
    window.analytics.track(title, props)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('window.analytics is unavailable')
  }
}

export const segmentIdentify = (email: string, props?: {}) => {
  try {
    window.analytics.identify(email, props)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('window.analytics is unavailable')
  }
}

/**
 * Track script generator events
 */
interface ScriptGeneratorIdentifyEventProps {
  email: string;
  product: string;
}
export const scritpGeneratorIdentifyTrack = (data: ScriptGeneratorIdentifyEventProps) => {
  segmentIdentify('', data)
}
interface ScriptGeneratorApiCalledEventProps {
  contentType: string;
}

export const scritpGeneratorApiCalledTrack = (eventName: SCRIPT_GENERATOR_METHOD, data: ScriptGeneratorApiCalledEventProps) => {
  segmentTrack(eventName, data)
}

export const scritpGeneratorScriptGeneratedTrack = (eventName: SCRIPT_GENERATOR_METHOD, newData: any) => {
  const data = {
    nextToDo: newData?.nextToDo,
    personalizeVideoWith: newData?.personalizeVideoWith,
    productCalled: newData?.productCalled,
    scryptStyle: newData?.scryptStyle,
    videoFor: newData?.videoFor,
    productWebsite: newData?.productWebsite,
    workEmail: newData?.workEmail
  }
  segmentTrack(eventName, data)
}

interface ScriptGeneratorScriptContentCopiedEventProps {
  content: string;
}

export const scritpGeneratorScriptContentCopiedTrack = (eventName: SCRIPT_GENERATOR_METHOD, data: ScriptGeneratorScriptContentCopiedEventProps) => {
  segmentTrack(eventName, data)
}

export const scritpGeneratorScriptContentOpenedTrack = (eventName: SCRIPT_GENERATOR_METHOD) => {
  segmentTrack(eventName)
}
